export const SelectOptionsSession = [
  {
    label: '-',
    value: 0
  },
  {
    label: '1',
    value: 1
  },
  {
    label: '1.5',
    value: 1.5
  },
  {
    label: '2',
    value: 2
  },
  {
    label: '2.5',
    value: 2.5
  },
  {
    label: '3',
    value: 3
  },
  {
    label: '5',
    value: 5
  },
]

export const SelectOptionsInstructor = [
  {
    label: 'Gerald Chandler',
    value: 1
  },
  {
    label: 'Ian Price',
    value: 2
  },
  {
    label: 'Clyde Burns',
    value: 3
  },
  {
    label: 'Christina Walters',
    value: 4
  },
]